"use client";

import { useOrkestriaTheme } from "@/lib/theme";
import { cn } from "@/lib/utils/utils";

type FakiMarkProps = {
  className?: string;
  /**
   * Si es true, fuerza la variante clara (logo blanco) sin importar el tema.
   * Útil sobre fondos siempre oscuros (botón con bg-primary, etc).
   */
  forceLight?: boolean;
};

/**
 * Imagen del logo de Faki (usa el monograma O de Orkestria).
 * Se adapta al tema: en modo claro usa el variante oscuro,
 * en modos oscuros usa el variante claro.
 */
export function FakiMark({ className, forceLight }: FakiMarkProps) {
  const { theme } = useOrkestriaTheme();
  // faki-icon.png es negro sobre transparente → invertir en modos oscuros
  const dark = forceLight || theme !== "light";
  return (
    <img
      src="/landing/faki-icon.png"
      alt="Faki"
      className={cn("h-full w-full object-contain", className)}
      style={{ filter: dark ? "invert(1)" : "none" }}
      draggable={false}
    />
  );
}

/**
 * Loader animado: el logo de Faki desvaneciéndose de abajo hacia arriba en loop.
 * Pensado para mostrarse al lado de los 3 puntitos de "escribiendo".
 */
export function FakiLoader({
  className,
  forceLight,
}: {
  className?: string;
  forceLight?: boolean;
}) {
  return (
    <span
      className={cn(
        "ork-faki-loader inline-flex h-3.5 w-3.5 flex-shrink-0",
        className,
      )}
      aria-hidden
    >
      <FakiMark forceLight={forceLight} />
    </span>
  );
}
